import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "field is-grouped is-grouped-right" }
const _hoisted_2 = { class: "buttons are-right" }
const _hoisted_3 = {
  key: 0,
  type: "button",
  class: "button is-link"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Please confirm or click cancel to return.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_dialog = _resolveComponent("modal-dialog")
  const _component_RegistrationRenewalDialog = _resolveComponent("RegistrationRenewalDialog")
  const _component_RegistrationExpireNowDialog = _resolveComponent("RegistrationExpireNowDialog")
  const _component_RegistrationEditIncentiveProgramDialog = _resolveComponent("RegistrationEditIncentiveProgramDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.isCreateRfqVisible)
            ? (_openBlock(), _createBlock("button", _hoisted_3, "Create RFQ"))
            : _createCommentVNode("", true),
          (_ctx.isEditDraftVisible)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                type: "button",
                class: "button is-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToEdit()))
              }, "Edit"))
            : _createCommentVNode("", true),
          (_ctx.isEditIncentiveProgramVisible)
            ? (_openBlock(), _createBlock("button", {
                key: 2,
                type: "button",
                class: "button is-link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEditIncentiveProgramDialogVisible = true)),
                disabled: _ctx.noIncentiveProgramOptions,
                title: _ctx.noIncentiveProgramOptions ? 'No Incentive programs available' : ''
              }, " Edit Incentive Program ", 8, ["disabled", "title"]))
            : _createCommentVNode("", true),
          (_ctx.canCancelRenewal)
            ? (_openBlock(), _createBlock("button", {
                key: 3,
                type: "button",
                class: "button is-light is-primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmAction(_ctx.cancelRenewal, 'Cancel Renewal Request?')))
              }, "Cancel Renewal"))
            : _createCommentVNode("", true),
          (_ctx.canCancelSubmission)
            ? (_openBlock(), _createBlock("button", {
                key: 4,
                type: "button",
                class: "button is-light is-primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmAction(_ctx.cancelSubmission, 'Cancel Request?')))
              }, "Cancel Request"))
            : _createCommentVNode("", true),
          (_ctx.isReturnToDraftAfterRejectVisible)
            ? (_openBlock(), _createBlock("button", {
                key: 5,
                type: "button",
                class: "button is-light is-primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmAction(_ctx.returnToDraftAfterReject, 'Return to Draft?')))
              }, "Return to Draft"))
            : _createCommentVNode("", true),
          (_ctx.isSubmitRenewalVisible)
            ? (_openBlock(), _createBlock("button", {
                key: 6,
                type: "button",
                class: "button is-link",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isRenewalDialogVisible = true))
              }, "Renew"))
            : _createCommentVNode("", true),
          (_ctx.isExpireNowVisible)
            ? (_openBlock(), _createBlock("button", {
                key: 7,
                type: "button",
                class: "button is-outlined is-danger",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isExpireDialogVisible = true))
              }, "Expire Now"))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_modal_dialog, {
      active: _ctx.isConfirmDialogVisible,
      onDone: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resolveConfirmDialogAction($event)))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.confirmDialogTitle), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_RegistrationRenewalDialog, {
      isVisible: _ctx.isRenewalDialogVisible,
      modelValue: _ctx.renewalComments,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.renewalComments = $event)),
      onResolveDialogAction: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resolveRenewalDialogAction($event)))
    }, null, 8, ["isVisible", "modelValue"]),
    _createVNode(_component_RegistrationExpireNowDialog, {
      isVisible: _ctx.isExpireDialogVisible,
      modelValue: _ctx.expireNowComments,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.expireNowComments = $event)),
      onResolveDialogAction: _cache[12] || (_cache[12] = ($event: any) => (_ctx.resolveExpireNowDialogAction($event)))
    }, null, 8, ["isVisible", "modelValue"]),
    (_ctx.isEditIncentiveProgramVisible)
      ? (_openBlock(), _createBlock(_component_RegistrationEditIncentiveProgramDialog, {
          key: _ctx.registrationDetail.incentiveProgramName,
          isVisible: _ctx.isEditIncentiveProgramDialogVisible,
          modelValue: _ctx.incentiveProgramEditModel,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.incentiveProgramEditModel = $event)),
          incentivePrograms: _ctx.registrationDetail.incentiveProgramOptions,
          currentProgram: _ctx.registrationDetail.incentiveProgramName,
          onResolveDialogAction: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resolveEditIncentiveProgramDialogAction($event)))
        }, null, 8, ["isVisible", "modelValue", "incentivePrograms", "currentProgram"]))
      : _createCommentVNode("", true)
  ], 64))
}